'use client';

import React, { createContext, useContext, useState, useCallback } from 'react';

interface UIContextType {
  title: string;
  setTitle: (title: string) => void;
  onGoHome: (() => void) | null;
  setOnGoHome: (handler: (() => void) | null) => void;
  onOpenLeft: (() => void) | null;
  setOnOpenLeft: (handler: (() => void) | null) => void;
  onOpenDati: (() => void) | null;
  setOnOpenDati: (handler: (() => void) | null) => void;
  onOpenDocs: (() => void) | null;
  setOnOpenDocs: (handler: (() => void) | null) => void;
  onOpenImpostazioni: (() => void) | null;
  setOnOpenImpostazioni: (handler: (() => void) | null) => void;
}

const UIContext = createContext<UIContextType | undefined>(undefined);

export function UIProvider({ children }: { children: React.ReactNode }) {
  const [title, setTitle] = useState('');
  const [onGoHome, setOnGoHome] = useState<(() => void) | null>(null);
  const [onOpenLeft, setOnOpenLeft] = useState<(() => void) | null>(null);
  const [onOpenDati, setOnOpenDati] = useState<(() => void) | null>(null);
  const [onOpenDocs, setOnOpenDocs] = useState<(() => void) | null>(null);
  const [onOpenImpostazioni, setOnOpenImpostazioni] = useState<(() => void) | null>(null);

  return (
    <UIContext.Provider
      value={{
        title,
        setTitle,
        onGoHome,
        setOnGoHome,
        onOpenLeft,
        setOnOpenLeft,
        onOpenDati,
        setOnOpenDati,
        onOpenDocs,
        setOnOpenDocs,
        onOpenImpostazioni,
        setOnOpenImpostazioni,
      }}
    >
      {children}
    </UIContext.Provider>
  );
}

export function useUI() {
  const context = useContext(UIContext);
  if (context === undefined) {
    throw new Error('useUI must be used within a UIProvider');
  }
  return context;
}
